<!--all p-treeTable attributes must be set to its default values as stated in the primeng document-->
<p-treeTable [columns]="columns" [value]="value" [dataKey]="dataKey" class="common-ptable-wrapper" [rows]="rows"
             [sortField]="sortField" [sortOrder]="sortOrder" [sortMode]="sortMode" [multiSortMeta]="multiSortMeta" [(selection)]="selection"
             #treeTable [selectionMode]="selectionMode"
             (onNodeSelect)="onNodeSelectEmit($event)" (onNodeExpand)="onNodeExpandSaveStatus($event.node)" (onNodeCollapse)="onNodeCollapseSaveStatus($event.node)"
             [(contextMenuSelection)]="contextMenuSelection" [contextMenu]="contextMenu"
             [paginator]="paginator" [rowsPerPageOptions]="PrimeNgConfig.TableRowsPerPage">

  <ng-template pTemplate="caption">
    <app-default-caption [captionTemplate]="captionTemplate" [leftCaptionTemplate]="leftCaptionTemplate" [rightCaptionTemplate]="rightCaptionTemplate"
                         [searchCaptionTemplate]="searchCaptionTemplate" [disableSearch]="disableSearch"
                         [enabledExport]="enabledExport" [exportUsingTableColumn]="exportUsingTableColumn" [exportTableColumns]="exportTableColumns" [exportFileName]="exportFileName"
                         [dt]="treeTable" [value]="flatValue"></app-default-caption>
    <button *ngIf="enableAllRowExpansion"
            pButton type="button" [icon]="allRowsExpanded ? 'fa fa-sort-down' : 'fa fa-caret-right'" label="Expand/Collapse All"
            style="position:relative; left:10px;"
            (click)="onClickExpandOrCollapseAllRows()"></button>
  </ng-template>

  <ng-template pTemplate="header">
    <ng-container *ngTemplateOutlet="headerTemplate ? headerTemplate: defaultHeader ; context: {columns : columns} ">
    </ng-container>
  </ng-template>

  <ng-template pTemplate="body" let-rowNode let-rowData="rowData" let-columns="columns" let-expanded="expanded">
    <ng-container *ngTemplateOutlet="bodyTemplate ? bodyTemplate: defaultBody ; context: {columns : columns, rowNode: rowNode, rowData:rowData, expanded: expanded} ">
    </ng-container>
  </ng-template>

  <ng-template *ngIf="footerTemplate" pTemplate="footer" let-rowNode let-rowData="rowData" let-columns="columns">
    <ng-container *ngTemplateOutlet="footerTemplate; context: {columns : columns, rowNode:rowNode, rowData:rowData} ">
    </ng-container>
  </ng-template>

  <ng-template *ngIf="!disableEmptyMessage" pTemplate="emptymessage" let-columns>
    <ng-container *ngTemplateOutlet="emptyMessageTemplate ? emptyMessageTemplate: defaultEmptyMessage ; context: {columns : columns} ">
    </ng-container>
  </ng-template>

  <ng-template *ngIf="rowExpansionTemplate" pTemplate="rowexpansion" let-rowNode let-rowData="rowData" let-columns="columns" let-expanded="expanded">
    <ng-container *ngTemplateOutlet="rowExpansionTemplate ; context: {columns : columns, rowNode:rowNode, rowData:rowData, expanded: expanded} ">
    </ng-container>
  </ng-template>

</p-treeTable>

<ng-template #defaultHeader let-rowNode="rowNode" let-columns="columns">
  <tr [ttRow]="rowNode">
    <th *ngFor="let col of columns" tooltipPosition="top" [style]="col.columnStyle" [ttSortableColumn]="col.field" [pTooltip]="col.tooltip">
      <!--      <button *ngIf="enableAllRowExpansion && col.app === TableApp.Expansion" pButton-->
      <!--              type="button" [icon]="allRowsExpanded ? 'fa fa-sort-down' : 'fa fa-caret-right'" style="position:relative; left:-10px;"-->
      <!--              (click)="onClickExpandOrCollapseAllRows()"></button>-->
      {{col.header}}
      <p-treeTableSortIcon *ngIf="col.field!=='action' && !col.disableSortIcon && col.app!==TableApp.Expansion" [field]="col.field"></p-treeTableSortIcon>
    </th>
  </tr>
</ng-template>

<ng-template #defaultBody let-rowNode="rowNode" let-rowData="rowData" let-columns="columns" let-expanded="expanded">
  <tr [pSelectableRow]="rowData" [pContextMenuRow]="rowNode">
    <td *ngFor="let col of columns; let i = index" [style]="col.columnStyle" [ngSwitch]="col.field">
      <span class="p-column-title">{{col.header}}</span>
      <span class="p-cell">
        <p-treeTableToggler *ngIf="i===0" [rowNode]="rowNode"></p-treeTableToggler>
        <app-data-table-renderer [row]="rowData" [rowNode]="rowNode" [rowData]="rowData" [col]="col" [orgIds]="orgIds"></app-data-table-renderer>
      </span>
    </td>
  </tr>
</ng-template>

<ng-template #defaultEmptyMessage let-columns="columns">
  <tr>
    <td [attr.colspan]="columns?.length">
      No records found
    </td>
  </tr>
</ng-template>
